import { actionConstants } from '../actions/actionConstants';

const initState = {
  isFetching: false,
  sensor: {},
  assignedSensors: [],
  unassignedSensors: [],
  alarmStatus: [],
  alarmStatusByGroup: [],
  isCompleted: false,
  sensorInfo: [],
  errors: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConstants.CLEAR_ERROR:
      return { ...state, errors: '' };
    case actionConstants.START_FETCHING:
      return { ...state, isFetching: true, errors: '' };
    case actionConstants.RESET_COMPLETED:
      return { ...state, isCompleted: false };
    case actionConstants.GET_SENSOR_DETAIL_SUCCESS:
      return { ...state, sensor: action.data };
    case actionConstants.GET_SENSOR_DETAIL_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.EDIT_SENSOR_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_SENSOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ASSIGNED_SENSORS_SUCCESS:
      return { ...state, assignedSensors: action.data };
    case actionConstants.GET_ASSIGNED_SENSORS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_UNASSIGNED_SENSORS_SUCCESS:
      return { ...state, unassignedSensors: action.data };
    case actionConstants.GET_UNASSIGNED_SENSORS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.ASSIGN_SENSORS_SUCCESS:
      return { ...state, isCompleted: true };
    case actionConstants.ASSIGN_SENSORS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.REPLACE_SENSOR_SUCCESS:
      return { ...state, isCompleted: true };
    case actionConstants.REPLACE_SENSOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.UNASSIGN_SENSORS_SUCCESS:
      return { ...state, isCompleted: true };
    case actionConstants.UNASSIGN_SENSORS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.DELETE_ASSIGNED_SENSORS_SUCCESS:
      return { ...state, isCompleted: true };
    case actionConstants.DELETE_ASSIGNED_SENSORS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.UPDATE_ACTIVE_SENSOR_SUCCESS:
      return { ...state };
    case actionConstants.UPDATE_ACTIVE_SENSOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.UPDATE_ALERTS_SENSOR_SUCCESS:
      return { ...state };
    case actionConstants.UPDATE_ALERTS_SENSOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ALARM_STATUS_SUCCESS:
      return { ...state, alarmStatus: action.data };
    case actionConstants.GET_ALARM_STATUS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ALARM_STATUS_BY_GROUP_SUCCESS:
      return { ...state, alarmStatusByGroup: action.data };
    case actionConstants.GET_ALARM_STATUS_BY_GROUP_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_SENSORS_INFO_SUCCESS:
      return { ...state, sensorInfo: action.data, isFetching: false };
    case actionConstants.GET_SENSORS_INFO_FAILURE:
      return { ...state, errors: action.data, isFetching: false };
    default:
      return state;
  }
};
